import { Injectable } from '@angular/core';

import { NotificationCode, NotificationSeverity } from '../models/communication/app-enums.model';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    private static readonly notificationDurationMs = 3000;

    visible = false;
    code?: NotificationCode;
    severity = NotificationSeverity.Error;
    showCloseButton = false;

    private timeoutId?: ReturnType<typeof setTimeout>;

    show({ code, severity, showCloseButton }: { code: NotificationCode; severity: NotificationSeverity; showCloseButton: boolean }): void {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }

        this.visible = true;
        this.code = code;
        this.severity = severity;
        this.showCloseButton = showCloseButton;

        if (!showCloseButton) {
            this.timeoutId = setTimeout(() => this.hide(), NotificationService.notificationDurationMs);
        }
    }

    hide(): void {
        this.visible = false;
    }
}
